import {validation} from './validation';

export default class PatternValidation {
  constructor(input) {
    const pattern = (input.pattern && input.pattern.length) ? new RegExp(input.pattern) : null;
    this.test = validation.create((c) =>  pattern ? pattern.test(c) : true).test;
  }
}
